@if (!visibilityService.isMaintenanceMode()) {
<!-- <div
  class="relative min-h-screen overflow-hidden bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800 flex items-center justify-center px-6">

   <div class="absolute top-0 left-0 w-72 h-72 bg-cyan-500/20 blur-3xl rounded-full"></div>
  <div class="absolute bottom-0 right-0 w-80 h-80 bg-indigo-500/20 blur-3xl rounded-full"></div>

   <div
    class="relative z-10 w-full max-w-lg rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl shadow-2xl p-10 text-center">

     <div
      class="mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-cyan-500/10 border border-cyan-400/20 animate-pulse">
      <span class="text-5xl animate-spin-slow">⚙️</span>
    </div>

     <h1 class="text-4xl font-bold text-white tracking-tight mb-4">
      Under Maintenance
    </h1>

     <p class="text-slate-300 text-lg leading-relaxed mb-8">
      We’re currently improving your experience.
      <br>
      Please check back soon.
    </p>

     <div class="flex justify-center gap-2 mb-6">
      <span class="w-3 h-3 rounded-full bg-cyan-400 animate-bounce"></span>
      <span class="w-3 h-3 rounded-full bg-cyan-400 animate-bounce [animation-delay:0.15s]"></span>
      <span class="w-3 h-3 rounded-full bg-cyan-400 animate-bounce [animation-delay:0.3s]"></span>
    </div>

     <small class="text-slate-400 text-sm">
      Thank you for your patience 💙
    </small>
  </div>
</div> -->
} @else {
<router-outlet></router-outlet>
}